import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  Action,
  CompanyRoles,
  Entity,
  Permissions,
} from '../../types/permissions'
import { RootState } from '../store'

interface PermissionsState {
  permissions: Permissions | null
  companyRoles: CompanyRoles[]
}

const initialState: PermissionsState = {
  permissions: {},
  companyRoles: [],
}

const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setPermissions: (state, action: PayloadAction<Permissions>) => {
      state.permissions = action.payload || null
    },
    setCompanyRoles: (state, action: PayloadAction<CompanyRoles[]>) => {
      state.companyRoles = action.payload
    },
    clearPermissions: (state) => {
      state.permissions = null
      state.companyRoles = []
    },
  },
})

export const { setPermissions, setCompanyRoles, clearPermissions } =
  permissionsSlice.actions

export const selectPermissions = (state: RootState) =>
  state.permissions.permissions

export const selectCompanyRoles = (state: RootState) =>
  state.permissions.companyRoles

export const hasPermission = (
  permissions: Permissions | undefined,
  entity: Entity,
  action: Action
): boolean => {
  if (!permissions || !permissions[entity]) {
    return false
  }

  return !!permissions[entity]?.[action]
}

export default permissionsSlice.reducer
